var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select-search',_vm._b({attrs:{"value":_vm.value,"items":_vm.filtered},on:{"search":_vm.search,"change":_vm.change},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_vm._t("activator",null,null,data)]}},{key:"selection",fn:function(ref){
var id = ref.id;
return [_c('div',{staticClass:"px-1"},[_c('user-tag',{attrs:{"tag":_vm.findTag(id)}})],1)]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('user-tag',{attrs:{"tag":item}})]}}],null,true)},'base-select-search',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }